

const hasChild = (item) => {
    return item.children && item.children.length !== 0
}

function getMenuByRouter(list){
    var res = []
    list.forEach(item => {
        if (!item.meta || (item.meta && item.meta.showInMenu)) {
            let obj = {
                icon: (item.meta && item.meta.icon) || '',
                name: item.name,
                meta: item.meta,
                path: item.path,
                title: (item.meta && item.meta.title) || ''
            }
            if (hasChild(item)) {
                obj.children = getMenuByRouter(item.children)
            }
            res.push(obj)
        }
    })
    return res
}

function getSideMenuByRouter(list){
    var res = []
    list.forEach(item => {
        if (!item.meta || (item.meta && item.meta.showSideMenu)) {
            let obj = {
                icon: (item.meta && item.meta.icon) || '',
                name: item.name,
                meta: item.meta,
                path: item.path,
                title: (item.meta && item.meta.title) || ''
            }
            if (hasChild(item)) {
                obj.children = getSideMenuByRouter(item.children)
            }
            res.push(obj)
        }
    })
    return res
}



const formatNumber = n => {
    if (n == undefined || n == "null") {
        return "0";
    }
    if (n < 0) {
        return "0";
    }
    if (n < 1000) {
        return n.toString()
    } else if (n < 1000000) {
        let num = n / 1000;
        num = parseFloat(num.toFixed(1));
        return num + "K";
    } else if (n < 1000000000) {
        let num = n / 1000000;
        num = parseFloat(num.toFixed(1));
        return num + "M";
    } else { //以下方法一般不会用到
        let num = n / 1000000000;
        num = parseFloat(num.toFixed(1));
        return num + "MM";
    }
}


const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}


function padding(num, length) {
    for (var len = (num + "").length; len < length; len = num.length) {
        num = "0" + num;
    }
    return num;
}

/**
 * 格式化为 2020-09-01 16:00 格式的时间
 */
function formatFullDateTime(date) {
    if (!date){
        return "";
    }
    if (typeof (date) == 'string') {
        date = new Date(new Date(date+".000Z").getTime()-(8*3600*1000)); //转换为东八区时间
    }
    if (!date.getFullYear()) {
        return "";
    }
    var text = date.getFullYear() + "-" + padding(date.getMonth() + 1, 2) + "-" + padding(date.getDate(), 2) + " " + padding(date.getHours(), 2) + ":" + padding(date.getMinutes(), 2);

    return text;
}

/**
 * 格式化日期，如2019-08-06等格式字符串
 * date, 日期对象或者日期格式字符串
 */
function formatDate(date) {
    var now = new Date()
    if (typeof (date) == 'string') {
        date = new Date(new Date(date+".000Z").getTime()-(8*3600*1000)); //转换为东八区时间
    }
    if (!date || !date.getYear()) {
        return "";
    }
    var text = date.getFullYear() + "-" + padding(date.getMonth() + 1, 2) + "-" + padding(date.getDate(), 2);
    return text;
}


/**
 * 格式化日期，如08-06等格式字符串
 * date, 日期对象或者日期格式字符串
 */
function formatMonthDate(date) {
    var now = new Date()
    if (typeof (date) == 'string') {
        date = new Date(new Date(date+".000Z").getTime()-(8*3600*1000)); //转换为东八区时间
    }
    if (!date || !date.getYear()) {
        return "";
    }
    var text = padding(date.getMonth() + 1, 2) + "-" + padding(date.getDate(), 2);
    return text;
}



/**
 * 获取时间戳，单位为毫秒
 * @param dateTime， 字符串时间
 */
function getTimestamp(dateTime = null) {
    var timestamp;
    if (!dateTime) {
        timestamp = Number(new Date());
    } else if (typeof (dateTime) == "string") {
        timestamp = Number(new Date(new Date(dateTime+".000Z").getTime()-(8*3600*1000))); //IOS上必须要这么转才能获得正常时间
    }
    return timestamp
}


// 其他更多是格式化有如下:
// yyyy:mm:dd|yyyy:mm|yyyy年mm月dd日|yyyy年mm月dd日 hh时MM分等,可自定义组合
function timeFormat(dateTime = null, fmt = 'yyyy-mm-dd') {
    // 如果为null,则格式化当前时间
    // 如果为null,则格式化当前时间
    let date;
    if (!dateTime) {
        dateTime = Number(new Date());
        // date = new Date(dateTime);
    } else if (typeof (dateTime) == "string") {
        // dateTime = new Date(new Date(dateTime+".000Z").getTime()-(8*3600*1000)); //转换为东八区时间
        // dateTime = Number(dateTime);
        // dateTime = dateTime.replaceAll("-", "/")
        // dateTime = Number(new Date(dateTime));
        dateTime = Number(new Date(new Date(dateTime+".000Z").getTime()-(8*3600*1000)));
    }

    // 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
    if (dateTime.toString().length == 10)
        dateTime *= 1000;
    date = new Date(dateTime);

    // console.error("timezone1")
    // console.error(date.getTimezoneOffset() / 60)

    let ret;
    let opt = {
        "y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "h+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "s+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}

function orderStatusToStr(status) {
    let orderStatus = '';
    switch (status) {
        case 1:
            orderStatus = "待支付"
            break;
        case 2:
            orderStatus = "已取消"
            break;
        case 3:
            orderStatus = "待发货"
            break;
        case 4:
            orderStatus = "已确认"
            break;
        case 5:
            orderStatus = "部分发货"
            break;
        case 6:
            orderStatus = "已发货"
            break;
        case 7:
            orderStatus = "已完成"
            break;
        case 8:
            orderStatus = "已退款"
            break;
        case 9:
            orderStatus = "待审核"
            break;
        case 10:
            orderStatus = "审核不通过"
            break;
    }
    return orderStatus;
}

/**
 * 删除字符串左右两侧逗号和空格
 * @param str
 * @returns {*}
 */
function trimSpacesAndCommas(str) {
    return str.trim().replace(/^,+|,+$/g, '');
}

export default {
    getMenuByRouter: getMenuByRouter,
    getSideMenuByRouter: getSideMenuByRouter,
    hasChild: hasChild,
    formatFullDateTime:formatFullDateTime,
    formatDate:formatDate,
    formatMonthDate:formatMonthDate,
    getTimestamp:getTimestamp,
    timeFormat:timeFormat,
    orderStatusToStr:orderStatusToStr,
    trimSpacesAndCommas:trimSpacesAndCommas
}

